import React, { Component } from "react";
import "./navigation.css";
import { Navbar, Nav, NavItem, MenuItem } from "react-bootstrap";
// import { NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";

export default class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {}
  render() {
    return (
      <Navbar collapseOnSelect fixedTop bsClass="navbar">
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">
              <span className="navbar-brand">
                <img src={require("../img/logo.png")} alt="T&R editorial" />
              </span>
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight>
            <LinkContainer to="/nosotros">
              <NavItem>Nosotros</NavItem>
            </LinkContainer>
            <LinkContainer to="/libros">
              <NavItem>Libros</NavItem>
            </LinkContainer>
            {/* <LinkContainer to="/revistas">
              <MenuItem>Revistas</MenuItem>
            </LinkContainer> */}
            <LinkContainer to="/revistas/Axon">
              <MenuItem>Revistas</MenuItem>
            </LinkContainer>
            {/* <NavDropdown title="Revistas" id="basic-nav-dropdown">
              <LinkContainer to="/revistas/Axon">
                <MenuItem>Axon</MenuItem>
              </LinkContainer>
              <LinkContainer to="/revistas/Financial">
                <MenuItem>Financial & Tax</MenuItem>
              </LinkContainer>
            </NavDropdown> */}
            {/* <NavDropdown title="Consutoria" id="basic-nav-dropdown">
              <LinkContainer to="/consultoria/libro">
                <MenuItem>Como hacer un libro</MenuItem>
              </LinkContainer>
              <LinkContainer to="/consultoria/video">
                <MenuItem>Produccion de video</MenuItem>
              </LinkContainer>
              <LinkContainer to="/consultoria/correccion">
                <MenuItem>Correccion de estilo</MenuItem>
              </LinkContainer>
              <LinkContainer to="/consultoria/edicion">
                <MenuItem>Edicion de textos</MenuItem>
              </LinkContainer>
              <LinkContainer to="/consultoria/fotografia">
                <MenuItem>Fotografia produccion televisiva</MenuItem>
              </LinkContainer>
              <LinkContainer to="/consultoria/comunicacion">
                <MenuItem>Comunicacion politica</MenuItem>
              </LinkContainer>
            </NavDropdown> */}
            <LinkContainer to="/cursos">
              <MenuItem>Cursos</MenuItem>
            </LinkContainer>
            {/* <NavDropdown title="Cursos" id="basic-nav-dropdown">
              <LinkContainer to="/cursos/tesis">
                <MenuItem>Termina tu tesis</MenuItem>
              </LinkContainer>
              <LinkContainer to="/cursos/investigacion">
                <MenuItem>Equipos de investigación</MenuItem>
              </LinkContainer>
              <LinkContainer to="/cursos/formacion">
                <MenuItem>Formación de investigadores</MenuItem>
              </LinkContainer>
              <LinkContainer to="/cursos/redaccion">
                <MenuItem>Redacción infalible</MenuItem>
              </LinkContainer>
              <LinkContainer to="/cursos/casos">
                <MenuItem>Método de casos</MenuItem>
              </LinkContainer>
            </NavDropdown> */}
            <LinkContainer to="/universidad">
              <NavItem>Universidad DTCH</NavItem>
            </LinkContainer>
            <LinkContainer to="/contacto">
              <NavItem>Contacto</NavItem>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
  componentDidMount() {}
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/components/navigation.js